// extracted by mini-css-extract-plugin
module.exports =  {"update-banner":"update-banner-Ptf9o","button":"button-gIZIO","close":"close-yk7iw","icon":"icon-PD7TM","label":"label-cNVib"};